import { render, staticRenderFns } from "./purchase-products.vue?vue&type=template&id=61a40813&scoped=true"
import script from "./purchase-products.vue?vue&type=script&lang=js"
export * from "./purchase-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a40813",
  null
  
)

export default component.exports